<template>
  <div>
    <v-textarea rows="1"
                light
                outlined
                class="chat-input"
                color="primary"
                v-model="message"
                auto-grow
                dense
                small
                @keypress.enter.exact.prevent="submit"
                hide-details>
      <template v-slot:append>
        <v-btn @click="submit" :loading="loading" class="mb-2" icon small color="primary">
          <v-icon small>mdi mdi-send</v-icon>
        </v-btn>
      </template>
      <template v-slot:append-outer>
        <v-menu v-model="optionsMenu" top left>
          <template v-slot:activator="{on, attrs}">
            <v-btn v-on="on" v-bind="attrs" icon small color="primary">
              <v-icon>mdi mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense :class="$vuetify.breakpoint.smAndUp && 'py-0'">
            <v-list-item @click="startNewChat">
              <v-list-item-action>
                <v-icon>mdi mdi-chat-plus-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t('start_new_chat') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-textarea>
  </div>
</template>

<script>
export default {
  name: "ChatInput",
  props: ['loading'],
  data() {
    return {
      message: '',
      optionsMenu: false,
    }
  },
  methods: {
    submit() {
      if (this.loading) return;
      if (this.message.length === 0) return;
      this.$emit('submit', this.message)
      this.message = '';
    },
    startNewChat() {
      this.$emit('start-new-chat');
    }
  }
}
</script>

<style lang="scss">
.chat-input {
  fieldset {
    padding: 6px 12px;
    background-color: #fff;
    background-image: none;
    border: 1px solid #000;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  }

  &.v-input--is-focused {
    fieldset {
      border-width: 1px;
      border-color: #66afe9;
      outline: 0;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
    }
  }

  textarea {
    margin-top: 11px !important;
    margin-bottom: 6px !important;
  }

  .v-input__append-inner {
    align-self: start !important;
  }
}
</style>
